import React, { useState } from "react";
import Shape4 from "../assets/brand/about-shape-4.png";
import About1 from "../assets/shape/about-shape-1.png";
import About2 from "../assets/brand/about-shape-2.png";
import About5 from "../assets/brand/about-shape-5.png";
import Choose5 from "../assets/brand/choose-shape-2.png";
// import devInspiration from "../assets/All Images/inspiration.jpg";
import devInspiration from "../newimgs/Calling.png";
// import devInspiration1 from "../assets/All Images/inspiration1.jpg";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../Styles/About.css";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import pdf1 from "../assets/company-pdf/Company-Profile.pdf";
import play from "../assets/icons/play.png";
import play1 from "../assets/icons/play1.png";
import Untitled1 from "../assets/icons/Untitled2.png";
import "../Styles/seperate Comp Css/Modal.css";
import axios from "axios";
import Spinner from "./seperate Components/Spinner";
import config from "../config";
const About = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [isLoading, setLoading] = useState(false);

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobile", mobile);

    try {
      const response = await axios({
        method: "post",
        url: "https://mars.zithas.com/api/portfolio",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((response) => {
        axios({
          url: "https://mars.zithas.com/api/getindiapdf", //your url
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          alert("Plaese click ok button to Download Company Portfolio");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "company-porfolio.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      });

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <section className="bd-about-area pt-10 pb-10 aboutDiv">
        <div className="bd-about-shape-box about-main-responsive pt-100 ">
          {/* <img
            className="bd-about-shape bd-about-shape-2"
            src={Shape4}
            alt="shape img not found"
          /> */}
<div className="container about-container">
  <div className="row justify-content-center align-items-center">
    <div className="col-xl-5 col-lg-8 ">
      <div className="bd-about-img mb-30 d-flex justify-content-center align-items-center">
        <img
          src={devInspiration}
          style={{ width: "80%", height: "80%" }}
          className="xss-w-full rounded-10"
          alt="about img not found"
        />
      </div>
    </div>
    <div className="col-xl-7 col-lg-8 " style={{ display: "flex", alignItems: "center", height: "100%" }}>
      <div className="bd-about-text mb-30 pt-30 z-index" style={{ width: "100%" }}>
        <div className="bd-section-title-wrapper d-flex justify-content-center align-items-center flex-column">
          <h5 className="bd-section-subtitle mb-15" style={{ fontFamily: 'sans-serif' }}>
            Ambrella Consulting
          </h5>
          <h2 className="bd-section-title mb-25 md-pr-50" style={{ fontSize: "38px", fontFamily: 'sans-serif' }}>
            
             <span style={{ color: "#098fb4" }}>Consulting </span>
            is a higher calling{" "}
            {/* <span style={{ color: "#098fb4" }}>Excellence</span> */}
          </h2>
          <p className="mb-20" style={{fontSize:"16px"}}>
            guiding you to clarity, growth and successful outcomes
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


          {/* modal popup */}
          <div
            className="modal fade"
            id="portfolioModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content" style={{ width: "120%" }}>
                <div className="modal-header" style={{ border: "none" }}>
                  <h5 className="modal-title" id="exampleModalLabel">
                    Fill out the Details!
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{ marginLeft: "50px" }}
                  ></button>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "100%", paddingRight: "25px" }}>
                    {isLoading && <Spinner />}
                    <form onSubmit={onHandleSubmit}>
                      <div className="row" style={{ paddingTop: "23px" }}>
                        <div className="bd-contact-field mb-20">
                          <input
                            className="blog-form"
                            type="text"
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Name"
                            name="user_name"
                            required
                          />
                        </div>
                        <div className="bd-contact-field mb-20">
                          <input
                            type="email"
                            placeholder="Email"
                            onChange={(e) => setEmail(e.target.value)}
                            name="user_email"
                            required
                          />
                        </div>
                        <div className="bd-contact-field mb-20 ">
                          <input
                            type="text"
                            maxLength={10}
                            placeholder="Contact No"
                            onKeyPress={(event) => {
                              if (!/[0-9.]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onChange={(e) => setMobile(e.target.value)}
                            name="user_contact"
                            required
                          />
                        </div>
                        <div className="col-12 mb-20">
                          <div className="bd-contact-field">
                            <button type="submit" className="theme-btn">
                              Download
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="hello">
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659453801/website/home/portfolio-side_y0lpqc.jpg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </div>
  );
};

export default About;
